import React, { ReactNode, useState } from 'react';
import ModalComponent from '../../misc/ModalComponent';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StatusCode from '../../../util/StatusCode';
import { CorePrimarySchoolStatus } from '../../../models/CoreUser';
import { CoreDisplayableRef } from '../../../models/CoreModels';
import { useTranslation } from 'react-i18next';

interface Item {
    primarySchoolStatus: CorePrimarySchoolStatus
    schoolUnit: CoreDisplayableRef
}

interface PrimarySchoolModalProps {
    isOpen: boolean
    toggleModal: () => void
    saveStatus: StatusCode
    deleteOverridenPrimarySchool: () => void
    items: Item[]
    primarySchool: Item | undefined
    update: (updatedSchool: string) => void
    disabled: boolean
    getIcons: (primarySchoolStatus: CorePrimarySchoolStatus) => ReactNode[]
}


const PrimarySchoolModal: React.FC<PrimarySchoolModalProps> = (props: PrimarySchoolModalProps) => {
    const { t } = useTranslation(['schoolAdministration', 'common']);
    const [updatedSchool, setUpdatedSchool] = useState(props.primarySchool?.schoolUnit.id ?? undefined);

    const update = () => {
        if (updatedSchool !== undefined) {
            props.update(updatedSchool);
        }
    }

    return (
        <ModalComponent
            isOpen={props.isOpen}
            toggleModal={props.toggleModal}
            header={<p>{t('primarySchool.primarySchool', { ns: 'schoolAdministration' })} <a href="https://flowsync.se/help/flowsync/primary-school" target="_blank" rel="noreferrer"><FontAwesomeIcon className="documentation-icon fs-color" title={t('showHelp', {ns: 'common'})} icon="question-circle" /></a></p>}
            cancel={t('action.close', { ns: 'common' })}
            confirm={t('action.edit', { ns: 'common' })}
            update={() => update()}
            disabled={props.primarySchool?.schoolUnit.id === updatedSchool || props.disabled}
            saveStatus={props.saveStatus}
        >
            {props.items.map((s, i) => (
                <FormGroup check key={i}>
                    <Label><Input type="radio" name="primarySchool" value={s.schoolUnit.id} checked={updatedSchool === s.schoolUnit.id} onChange={e => setUpdatedSchool(e.target.value)} />
                        {s.schoolUnit.title} <span className="ml-2">{props.getIcons(s.primarySchoolStatus)}</span></Label>
                </FormGroup>
            ))}

            <Button disabled={!props.primarySchool?.primarySchoolStatus.overriddenPrimary || props.disabled} onClick={props.deleteOverridenPrimarySchool}>{t('primarySchool.clearManuallyPrimarySchool', { ns: 'schoolAdministration' })}</Button>

        </ModalComponent>
    );
}

export default PrimarySchoolModal;
